import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Explore from "./components/Explore";
import FeaturedNews from "./components/Featured";
import UpcomingEvents from "./components/UpcomingEvents";
import DirectoryPage from "./pages/DirectoryPage";
import MemberDetailPage from "./pages/MemberDetailPage";
import MembershipPage from "./pages/MembershipPage";
import NewsPage from "./pages/NewsPage";
import NewsDetailPage from "./pages/NewsDetailPage";
import AboutPage from "./pages/AboutPage";
import BenefitsPage from "./pages/BenefitsPage";
import ContactPage from "./pages/ContactPage";
import AdminPage from "./pages/AdminPage";
import CheckInPage from "./pages/CheckInPage";
import EventsPage from "./pages/EventsPage";
import UnsubscribePage from "./pages/UnsubscribePage";
import EventDetailPage from "./pages/EventDetailPage";

const Home = () => (
  <>
    <Hero />
    <Explore />
    <UpcomingEvents />
    <FeaturedNews />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/directory" element={<DirectoryPage />} />
          <Route path="/directory/:id" element={<MemberDetailPage />} />
          <Route path="/membership" element={<MembershipPage />} />
          <Route path="/benefits" element={<BenefitsPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/news/:id" element={<NewsDetailPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/unsubscribe" element={<UnsubscribePage />} />
          <Route path="/events/:id" element={<EventDetailPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/checkin/:id" element={<CheckInPage />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
